
import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Homepage from './pages/Homepage';
import Aboutpage from './pages/Aboutpage';
import Contactpage from './pages/Contactpage';

import Privacypage from './pages/Privacypage';

import HouseholdheaderPage from './pages/HouseholdheaderPage';
import Officecleanoutpage from './pages/Officecleanoutpage';
import Garagecleanoutpages from './pages/Garagecleanoutpages';
import Constructiondebrispage from './pages/Constructiondebrispage';
import Foreclosuresheaderpage from './pages/Foreclosuresheaderpage';
import Donationpage from './pages/Donationpage';

import Junkremovapage from './pages/Junkremovapage';





// NEW: Scroll to #section if hash exists
const ScrollToHashElement = () => {
  const location = useLocation();

  React.useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 200); // Timeout ensures DOM is ready
      }
    }
  }, [location]);

  return null;
};


const ScrollToTop = () => {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const App = () => {
  return (
    <>

      <ScrollToTop />
      <ScrollToHashElement />
      <Routes>

        <Route path='/' element={<Homepage />} />
        <Route path='/about' element={<Aboutpage />} />
        <Route path='/contact' element={<Contactpage />} />

        <Route path='/privacy' element={<Privacypage />} />

        <Route path='/services/household-junk' element={<HouseholdheaderPage />} />
        <Route path='/services/YardDebrisRemoval' element={<Officecleanoutpage />} />
        <Route path='/services/garage-cleanouts' element={<Garagecleanoutpages />} />
        <Route path='/services/construction-debris' element={<Constructiondebrispage />} />
        <Route path='/services/Foreclosures&Evictions' element={<Foreclosuresheaderpage />} />
        <Route path='/services/Donationpickups' element={<Donationpage/>}/>
        <Route path='/services/Junkremoval' element={<Junkremovapage/>}/>



      </Routes>
    </>
  );
};

export default App;
